import { toastTypeArray } from 'helpers/toastFactory';
import { FlowsterStudioLicenceModel } from './FlowsterStudioLicenceType';

//Entities Backend
export interface Address {
  guid: string;
  id: number;
  strasse?: string;
  plz?: string;
  stadt?: string;
  land?: string;
  bundesland?: string;
}

export interface CustomerToAddress {
  id: number;
  customerId: number;
  addressId: number;
}

export interface Customer {
  guid: string;
  id: number;
  name?: string;
  projectfactsOrgaId?: number;
  deleted: boolean;
  createdAt: string;
  addresses?: Address[];
  users?: UserToCustomer[];
}

export interface User {
  guid: string;
  id: number;
  email: string;
  passwordHash?: string;
  imageUrl?: string;
  firstname?: string;
  lastname?: string;
  fremdId?: number;
  contactMail?: string;
  contactPhone?: string;
  rememberMe?: boolean;
  language?: string;
  role: Role;
  userToCustomer?: UserToCustomer;
}

export interface UserToCustomer {
  id: number;
  userId: number;
  customerId: number;
  customer: Customer;
  user: User;
}
export enum Role {
  admin = 1,
  customeradmin = 2,
  user = 3,
}
//Entities End
export interface ServerMessageResponse {
  type: (typeof toastTypeArray)[number];
  message: string;
}
export interface UserDTO {
  guid: string;
  contactMail?: string;
  contactPhone?: string;
  email: string;
  firstname?: string;
  language?: string;
  id: number;
  imageUrl?: string;
  lastname?: string;
  role: string;
  userToCustomer?: null;
  createdAt: string | null;
  permissions?: string[];
  rolePermissions?: string[];
  userPermissions?: string[];
  isActive?: boolean;
}
export type UserModel = UserDTO
///api/Admin/UserToCustomer
export interface UserToCustomerResponse {
  customer: {
    guid: string;
    id: number;
    name: string;
    projectfactsOrgaId: number;
    deleted: boolean;
  };
  user: UserModel;
}
///api/Admin/GetSingleCustomerWithUsers/{id}
export interface GetSingleCustomerWithUsersResponse {
  guid: string;
  id: number;
  name: string;
  customerId: string;
  deactivated: boolean;
  projectFactsOrgaId: number;
  users?: UserDTO[];
}
///api/Admin/GetOnlyUsersWithoutRelation

export interface GetOnlyUsersWithoutRelationResponse extends UserDTO {}
///api/Admin/GetCustomerWithUsers
export interface GetCustomerWithUsersResponse
  extends GetSingleCustomerWithUsersResponse {}

///api/Customer/GetAll
export interface CustomerGetAllResponse {
  guid: string;
  id: number;
  name: string;
  projectfactsOrgaId: number;
  deleted: boolean;
  users: null;
  addresses: null;
  createdAt: null;
}
///api/Customer/{id}
export interface CustomerByIdResponse extends Customer {}
///api/Customer/getWithAddress/{id}
export interface getWithAddressResponse {
  customerId: number;
  addressId: number;
  addressModel: Address;
  customerModel: Customer;
}
///api/Customer/{id}/with-details
export interface getCustomerWithDetailsResponse {
  deleted: boolean;
  guid: string;
  id: number;
  customerId: string;
  name: string;
  projectFactsOrgaId: number;
  addresses?: Address[];
  users?: UserDTO[];
}

///api/IsValid
export interface IsValidResponse extends UserDTO {}
///api/Role
export interface RoleResponse {
  id: number;
  name: string;
}
export interface LoginServerResponse {
  type?: string | null;
  message?: string | null;
  user: UserDTO;
  token?: string | null;
}

export interface AllUserOptionalWithCustomerResponse extends UserDTO {
  customer: Customer;
}
export interface UserWithCustomer {
  guid: string;
  contactMail?: string;
  contactPhone?: string;
  email: string;
  firstname?: string;
  id: number;
  imageUrl?: string;
  lastname?: string;
  role: string;
  permissions?: string[];
  rolePermissions?: string[];
  userPermissions?: string[];
  customer?: {
    guid: string;
    id: number;
    name: string;
    customerId: string;
    projectfactsOrgaId?: string;
    addresses?: Address[];
  };
}
export type productTypes =
  | 'FSM'
  | 'Password Reset Portal'
  | 'Flowster Studio'
  | 'Flowster AI Studio';
export type flowsterStudioLicenceTypes =
  | 'Elements'
  | 'Standard'
  | 'Professional'
  | 'Enterprise';
export interface LicenceResponseAdmin {
  guid: string;
  id: number;
  encrypted: string;
  json: string;
  blob: string;
  product: productTypes;
  deleted: boolean;
  createdAt: string;
  customerID?: number;
  customer?: Customer;
  fileName: string;
}
export interface FSM_Licence {
  Company: string;
  Id: number;
  Maintenance: {
    From: string;
    Till: string;
  };
  MaxUsers: number;
  Partner: string;
  Product: string;
  Subscription: {
    Type: string;
    From: string;
    Till: string | null;
  };
  Support: {
    From: string;
    Till: string;
  };
  Version: string;
}
export interface FlowsterStudioReset {
  Version: string;
  Id: number;
  MaxUsers: number;
  Product: string;
  Subscription: {
    From: string;
    Till: string;
  };
  Support: {
    Available: boolean;
    Perpetual: string;
    Type: string;
    From: string;
    Till: string;
  };
}
/**
 * Stored licence JSON for product 'Flowster AI Studio'.
 * Payload of the vendor-signed JWS key (ES384), serialized by the backend
 * (see FlowsterAIStudioLicenseModel.cs). Limit values of -1 mean "unlimited".
 */
export interface FlowsterAIStudioLicence {
  /** Issuer ("flowster-vendor") */
  iss: string;
  /** Installation-ID */
  sub: string;
  /** Unix seconds */
  iat?: number | null;
  nbf?: number | null;
  /** null = perpetual licence */
  exp?: number | null;
  issuedTo: string;
  planName: string;
  planTier?: number | null;
  telemetryEndpoint?: string | null;
  maxUsers?: number | null;
  maxForms?: number | null;
  maxApps?: number | null;
  aiTokenQuotaMonthly?: number | null;
  features: Record<string, boolean>;
  /** ISO date strings derived from nbf/exp; null = perpetual */
  validFrom?: string | null;
  validUntil?: string | null;
  /** validUntil + 30 days grace period */
  graceUntil?: string | null;
}

export type LicenceTypes =
  | FSM_Licence
  | FlowsterStudioReset
  | FlowsterStudioLicenceModel
  | FlowsterAIStudioLicence;

export interface CustomerWithLicense {
  licences?: Array<any>;
}

//=====================================================================
//                          Mail Manager Types
//=====================================================================
export type MailRequestStatus = 'Pending' | 'Sending' | 'Sent' | 'Failed';

export interface MailRequestModel {
  guid: string;
  recipient: string;
  templateKey: string;
  language: string;
  subject: string;
  body: string;
  status: MailRequestStatus;
  createdAt: string;
  sentAt?: string | null;
  errorMessage?: string | null;
}

export enum MailSendMode {
  Disabled = 0,
  Auto = 1,
  Manual = 2,
}

export interface TemplatesModel {
  guid: string;
  templateKey: string;
  language: string;
  subject: string;
  bodyHtml: string;
  sendMode: MailSendMode;
  expiryWarningDays?: number;
  updatedAt: string;
}

export interface MailTemplateVariable {
  key: string;
  label: string;
}

// ============================================================
// SOFTWARE (matches Models/DTO/Software/SoftwareModel.cs)
// ============================================================
export interface SoftwareModel {
  guid: string;
  name: string;
  description?: string | null;
  /** When true, the software is enabled for all customers by default. */
  globalEnabled: boolean;
  createdAt?: string | null;
}

export interface CreateSoftwareModel {
  name: string;
  description?: string | null;
}

export type UpdateSoftwareModel = CreateSoftwareModel;

// Admin per-customer view (CustomerSoftwareAccessModel.cs)
export interface CustomerSoftwareAccessModel {
  softwareGuid: string;
  name: string;
  description?: string | null;
  launchUrl?: string | null;
  shareFolderName?: string | null;
  enabled: boolean;
}

export interface SetSoftwareAccessModel {
  customerGuid: string;
  softwareGuid: string;
  enabled: boolean;
}

// Allow-list of products a customer may see on the Downloads page
// (CustomerVisibleProductsModel.cs). Names are lower-cased.
export interface CustomerVisibleProductsModel {
  customerGuid: string;
  visibleProducts: string[];
}
